<!-- "More info" dropdown for a goal's `info` text (ZiLL descriptions, GO! Navigator
     examples and MIA info lines). The text is plain, pre-wrapped — the mapper folds
     headings and bullet lines into it with newlines. -->
<template>
	<div class="dropdown dropdown-end dropdown-top">
		<div tabindex="0" role="button" class="btn-more-info">{{ $t("More info") }}</div>
		<div
			tabindex="0"
			class="dropdown-content card shadow ring-1 ring-inset ring-base-200 bg-base py-2 px-4 w-96 whitespace-pre-wrap z-20 text-left font-normal"
			v-text="info"
		></div>
	</div>
</template>

<script lang="ts">
export default {
	props: {
		info: {
			type: String,
			required: true,
		},
	},
};
</script>
